/* eslint-disable react/prop-types */
import React, { lazy, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import useUtilities from '../hooks/useUtilities';

const Auth = lazy(() => import('../screens/Auth'));
const Login = lazy(() => import('../screens/Auth/Login'));
const CheckIn = lazy(() => import('../screens/Auth/Login/CheckIn'));
const ForgotPassword = lazy(() => import('../screens/Auth/ForgotPassword'));
const ResetPassword = lazy(() => import('../screens/Auth/ResetPassword'));

const PublicRoute = ({ as: Component, ...props }) => {
  const { isSoloInstructor, getBaseUrlForDashboard } = useUtilities();
  const { company } = useParams();
  const [cookies] = useCookies();
  const navigate = useNavigate();

  useEffect(() => {
    if (cookies.token && cookies.user) {
      if (isSoloInstructor()) {
        const dashboardPath = getBaseUrlForDashboard();
        window.location.href = `${dashboardPath}${company}/dashboard`;
      } else {
        navigate('./app');
      }
    }
  }, [company, cookies.token, cookies.user, getBaseUrlForDashboard, isSoloInstructor, navigate]);

  return <Component {...props} />;
};

const authNav = [
  {
    path: 'login',
    element: <Login />,
  },
  {
    path: 'forgotPassword',
    element: <ForgotPassword />,
  },
  {
    path: 'resetPassword/:token',
    element: <ResetPassword />,
  },
  {
    path: 'check-in/:fitnessSessionId',
    element: <CheckIn />,
  },
];

const authRoutes = [
  {
    path: '/',
    element: <PublicRoute as={Auth} />,
    children: authNav,
  },
  {
    path: '/:company/:roleId/',
    element: <PublicRoute as={Auth} />,
    children: authNav,
  },
];

export default authRoutes;
